export const GET_INVOICE_FILE = "/invoicing/invoices/getFileUrl";
export const VALIDATE_PASSWORD = "/auth/password/validate";
export const REFRESH_TOKEN = "/auth/refresh-token";
